<template>
    <div class="bg-white mark_the_exam pb-5">
        <header-mark-the-exam :currentTest="currentTest" :isChildTest ="+centerID === Cambridge_Mentor_ID"></header-mark-the-exam>
        <div class="container  mt-10" v-if="+centerID === Cambridge_Mentor_ID ">
            <TestSpeakingChild></TestSpeakingChild>
        </div>
        <div class="container  mt-10" v-else>
<!--            <test-writing v-if="currentTest==TEST_WRITING" :doneTest="doneTest" @change="currentTest=SUGGESTED_COURSE"></test-writing>-->
<!--            <test-speaking v-if="currentTest==TEST_SPEAKING" :doneTest="doneTest" @change="currentTest=SUGGESTED_COURSE"></test-speaking>-->
          <MarkWritingHighBand v-if="isHighBand&&+currentTest===TEST_WRITING" :aiResult="aiResult"></MarkWritingHighBand>
          <NewMarkSpeaking
              v-else-if="+currentTest===TEST_SPEAKING"
              :criteria="speakingCriteria"
          ></NewMarkSpeaking>
          <NewMarkWriting v-else-if="+currentTest===TEST_WRITING" :aiResult="aiResult"></NewMarkWriting>
        </div>
    </div>
</template>

<script>
import HeaderMarkTheExam from "@/view/pages/test-input/components/ComponentMarkTheExam/HeaderMarkTheExam";
import CustomerInformation from "@/view/pages/test-input/components/ComponentMarkTheExam/CustomerInformation";
import TestWriting from "@/view/pages/test-input/components/ComponentMarkTheExam/TestWriting";

import TestSpeaking from "@/view/pages/test-input/components/ComponentMarkTheExam/TestSpeaking";

import {SPEAKING, TEST_SPEAKING, TEST_WRITING, WRITING} from "@/core/option/testInputOption";
import {GET_RESULT_EXAM, GET_WRITING_AI_RESULT} from "@/core/services/store/test/testInput.module";
import SuggestedCourse from "@/view/pages/test-input/components/ComponentMarkTheExam/SuggestedCourse";
import {Cambridge_Mentor_ID, MENTOR_ENGLISH_MASTERY} from "@/core/option/typeCenterBill";
import TestSpeakingChild from "@/view/pages/test-input/components/ComponentMarkTheExam/TestSpeakingChild.vue";
import NewMarkSpeaking from "@/view/pages/test-input/components/ComponentMarkTheExam/NewMarkSpeaking.vue";
import NewMarkWriting from "@/view/pages/test-input/components/ComponentMarkTheExam/NewMarkWriting.vue";
import MarkWritingHighBand from "./ComponentMarkTheExam/MarkWritingHighBand.vue";
import {SecondarySpeakingCriteria, SecondarySpeakingCriteriaV2, SpeakingCriteria} from "@/core/option/newTestInputOption";


export default {
    name: "AssignmentGradingActivities",
    components: {
      MarkWritingHighBand,
      NewMarkWriting,
      NewMarkSpeaking,
        TestSpeakingChild,
        SuggestedCourse,
        TestSpeaking,
        TestWriting,
        CustomerInformation,
        HeaderMarkTheExam
    },
    props: {
        speakingRubricVersion: {
            type: [Number, String],
            default: 2
        }
    },
    data() {
        return {
            currentTest: this.$route.query.typeMark,
            TEST_SPEAKING: 0,
            TEST_WRITING: 1,
            SUGGESTED_COURSE: 2,
            testIELTS: false,
            doneTest: false,
            idSchedule:null,
            centerID : this.$route.query.centerID,
            Cambridge_Mentor_ID: Cambridge_Mentor_ID,
            MENTOR_ENGLISH_MASTERY: MENTOR_ENGLISH_MASTERY,
            aiResult: null
        }
    },
    created() {
        this.getWritingAiResult();
    },
    mounted() {
        
    },
    computed: {
        isHighBand() {
        return this.$route.query?.isHighBand != 0;
      },
        isMasteryCenter() {
        return +this.centerID === this.MENTOR_ENGLISH_MASTERY;
      },
        secondarySpeakingVersion() {
        return this.isMasteryCenter && +this.speakingRubricVersion === 2 ? 2 : 1;
      },
        speakingCriteria() {
        if (!this.isMasteryCenter) {
          return SpeakingCriteria;
        }

        return this.secondarySpeakingVersion === 2 ? SecondarySpeakingCriteriaV2 : SecondarySpeakingCriteria;
      }
    },
    methods: {
        async getWritingAiResult() {
            let test_input_schedule_id = this.$route.params.id;
            try {
                let data = await this.$store.dispatch(GET_WRITING_AI_RESULT, test_input_schedule_id);
                if (!data.error) {
                    this.aiResult = data.data;
                }
            } catch (error) {
                console.error(error);
            }
        },
        async getResultTests() {
            let test_input_schedule_id = this.$route.params.id
            let data = await this.$store.dispatch(GET_RESULT_EXAM, test_input_schedule_id ?? 0);
            if (!data.error) {
                this.idSchedule = data.data.test_input_schedule_id
                let keys = ["speaking", "writing", "listening", "vocabulary", "reading"];
                if (data.data?.vocabulary?.right_answers > 1) {
                    keys = ["speaking", "writing", "listening", "reading"];
                    this.testIELTS = true
                } else {
                    keys = ["speaking", "vocabulary"];
                }
                let count = 0
                let res = keys.forEach((obj) => {
                    if (!data?.data?.hasOwnProperty(obj) || data.data[obj] == null) {
                        return
                    }
                    count++
                })
                this.doneTest = (this.testIELTS && (count == 3|| count ==4 ) ) || (!this.testIELTS && ((count == 1 && data?.data?.speaking == null  ) ||count == 2 ))
                this.currentTest = (!this.testIELTS && this.currentTest == WRITING && data.data[speaking] != null) ? 2 : this.$route.query.typeMark
                if((count == 4 && this.testIELTS) || (count == 2 && !this.testIELTS)){
                    this.currentTest = 2
                }
            }
        }
    }
}
</script>

<style scoped>
.mark_the_exam {
    height: 100%;
}

.mark_the_exam {
    box-sizing: border-box;
}
</style>
